import script from "./newsletter-articles.vue?vue&type=script&setup=true&lang=ts"
export * from "./newsletter-articles.vue?vue&type=script&setup=true&lang=ts"

import "./newsletter-articles.vue?vue&type=style&index=0&id=6160dadd&lang=scss"

const __exports__ = script;

export default __exports__